import React, { lazy } from 'react';
import { Route } from 'react-router-dom';

const AllBooks = lazy(() => import('../components/data/all-books/AllBooks'));
const AmazonPulls = lazy(() => import('../components/data/amazon-pulls/AmazonPulls'));
const DistributorStockAssessment = lazy(() => import('../components/data/distributor-stock/DistributorStockAssessment'));
const BulkLookup = lazy(() => import('../components/data/bulk-lookup/BulkLookup'));
const SkuSearcher = lazy(() => import('../components/data/sku-searcher/SkuSearcher'));
const NielsenBookscanDrop = lazy(() => import('../components/data/nielsen-bookscan-drop/NielsenBookscanDrop'));
const ManualStocklistUpload = lazy(() => import('../components/data/manual-stocklist-upload/ManualStocklistUpload'));
const KeepaDashboard = lazy(() => import('../components/data/keepa/KeepaDashboard'));
const KeepaSearch = lazy(() => import('../components/data/keepa-search/KeepaSearch'));
const StockFlows = lazy(() => import('../components/data/stock-flows/StockFlows'));
const InvoiceTraceability = lazy(() => import('../components/data/stock-flows/InvoiceTraceability'));
const OrderPredictor = lazy(() => import('../components/data/order-predictor/OrderPredictor'));
const BsrCurvesPage = lazy(() => import('../components/data/bsr-curves/BsrCurvesPage'));
const ManualProductImport = lazy(() => import('../components/data/manual-product-import/ManualProductImport'));

export const dataRoutes = (
  <>
    <Route path="/all-books" element={<AllBooks />} />
    <Route path="/amazon-pulls" element={<AmazonPulls />} />
    <Route path="/lookup" element={<BulkLookup />} />
    <Route path="/sku-searcher" element={<SkuSearcher />} />
    <Route path="/keepa" element={<KeepaDashboard />} />
    <Route path="/keepa-search" element={<KeepaSearch />} />
    <Route path="/stock-flows" element={<StockFlows />} />
    <Route path="/stock-flows/traceability" element={<InvoiceTraceability />} />
    <Route path="/bsr-curves" element={<BsrCurvesPage />} />
    <Route path="/manual-product-import" element={<ManualProductImport />} />
    <Route path="/nielsen-bookscan-drop" element={<NielsenBookscanDrop />} />
    <Route path="/manual-uploads" element={<ManualStocklistUpload />} />
    <Route path="/distributor-stock" element={<DistributorStockAssessment />} />
    <Route path="/order-predictor" element={<OrderPredictor />} />
  </>
);
